import { Stage } from '@nucleus/ncu-constants';
import { getTableName } from './dynamodb';

export const TABLE_NAME_FLOWS = getTableName('flows', 'NucleusPlatformResources', Stage);
export const TABLE_NAME_LAUNCHER = getTableName('launcher', 'NucleusPlatformResources', Stage);
export const TABLE_NAME_LAUNCHERURL = getTableName('launcherurl', 'NucleusPlatformResources', Stage);
export const TABLE_NAME_MASTER = getTableName('master', 'NucleusPlatformResources', Stage);
/**
 * @deprecated use `import { MessagesTableName } from '@nucleus/ncu-constants'`
 */
export const TABLE_NAME_MESSAGES = getTableName('messages', 'NucleusPlatformResources', Stage);
export const TABLE_NAME_PRAYER = getTableName('prayer', 'NucleusPlatformResources', Stage);
export const TABLE_NAME_SUBMISSION = getTableName('submission', 'NucleusPlatformResources', Stage);

export const MASTER_TABLE_TTL_ATTRIBUTE = 'delete_after';
